<template>
	<ProcessCreatePage class="flex flex-col">
		<Header title="Neue Auftragsdokumentation anlegen - Übersichtsfoto"> {{ $t('take_image_of_vehicle') }} - {{ $t('tablet_horizontal') }} </Header>

		<div class="main">
			<BaseCamera
				orientation="landscape"
				@snapshot="overviewImage = $event"
				:label="$t('add_overview_image')"
				:take-image-label="$t('activate_camera')"
				:remove-upload-button="isAppContainer"
				:take-image="true"
				:allow-upload-in-app-container="false"
			/>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="!overviewImage"
			:is-back-button="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import BaseCamera from '@/components/forms/inputs/BaseCamera';
import Header from '@/components/damagecases/Header';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateOrderDocumentationOverviewImage',
	components: { ProcessCreatePage, Header, BaseCamera, Footer },
	mixins: [AppContainerMixin],
	data() {
		return {
			overviewImage: null,
		};
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$swal({
					title: this.$t('store_mileage').toString(),
					text: this.$t('update_vehicles_mileage').toString(),
					icon: 'question',
					input: 'number',
					inputValue: this.vehicleKilometrage,
					confirmButtonText: this.$t('update').toString(),
					cancelButtonText: this.$t('general.no').toString(),
					inputPlaceholder: '1244',
					validationMessage: this.$t('enter_valid_number').toString(),
					inputAttributes: {
						minNumber: 1,
						maxLength: 6,
					},
					inputValidator: inputValue => {
						if (isNaN(inputValue)) {
							return this.$t('enter_valid_number').toString();
						} else if (!inputValue) {
							return this.$t('enter_number').toString();
						}
					},
					showCancelButton: true,
				}).then(result => {
					this.$store.commit('setProcessCreateOrderDocumentationOverviewImage', this.overviewImage);
					if (result.value) {
						this.$store.commit('setProcessCreateOrderDocumentationVehicleKilometrage', result.value);
					}
					this.$emit('next');
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('upload_or_skip').toString(), 'warning');
			}
		},
		validate: function() {
			return !!this.overviewImage;
		},
	},
};
</script>

<style scoped></style>
